@if (useJkuShell()) {
<!-- JKU users stay in the JKU look on every screen — the shell brings its own router-outlet,
     header and sidebar, so no lib-app-layout and no app-menu here. -->
<app-jku-layout></app-jku-layout>
}
@else if (isHandset()) {
<lib-app-mobile-first-layout [appTitle]="''">
  <app-menu></app-menu>
  <router-outlet></router-outlet>
  <!-- Bottom navigation for mobile -->
  <app-bottom-nav-menu slot="bottom-nav" class="bottom-nav"></app-bottom-nav-menu>
</lib-app-mobile-first-layout>
}
@else {
<lib-app-layout [appTitle]="''">
  <app-menu></app-menu>
  <router-outlet></router-outlet>
</lib-app-layout>
}
